module.exports = __webpack_public_path__ + "static/media/manutenzioni.fd9485f6.jpg";